import React from 'react'
import './index.css'

export const PreloaderRing = () => (<div className="lds-ring"><div></div><div></div><div></div><div></div></div>)
export const PreloaderRingMin = () => (<div className="lds-ring-min"><div></div><div></div><div></div><div></div></div>)
